/**
 * @author Красильников Даниил <dkrasilnikov@gmail.com>
 * @link https://t.me/krasilneg
 * 
 * @author Колесник Данил <90.kalias.3@gmail.com>
 * @link https://t.me/kalias_90
 */

export type IntersectionListenerHandler = (
  entry: IntersectionObserverEntry,
  listener: IntersectionListener
) => void | Promise<void>;

export default class IntersectionListener {
  private observer: IntersectionObserver;
  private handlers: Map<Element, { h: IntersectionListenerHandler, once?: true }>;

  constructor({ root, threshold }: IntersectionObserverInit) {
    this.handlers = new Map();
    this.observer = new IntersectionObserver(
      async (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            this.onIntersect(entry);
          }
        }
      },
      {
        root,
        threshold,
      }
    );
  }

  private async onIntersect(entry: IntersectionObserverEntry): Promise<void> {
    if (this.handlers.has(entry.target)) {
      const { h, once } = this.handlers.get(entry.target)!;
      h(entry, this);
      if (once) this.forget(entry.target);
    }
  }

  listen(e: Element, h: IntersectionListenerHandler, once?: true): void {
    const isObserved = this.handlers.has(e);
    this.handlers.set(e, { h, once });
    if (!isObserved) {
      this.observer.observe(e);
    }    
  }

  forget(e: Element): void {
    if (this.handlers.has(e)) {
      this.observer.unobserve(e);
      this.handlers.delete(e);
    }
  }

  disconnect(): void {
    this.observer.disconnect();
    this.handlers.clear();
  }
}